// extracted by mini-css-extract-plugin
module.exports = {"content":"Content057_content__prPEt","wrapper":"Content057_wrapper__QRejw","wide":"Content057_wide__G2NlN"};